/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddSerialNumberPayload
 */
export interface AddSerialNumberPayload {
    /**
     * 
     * @type {string}
     * @memberof AddSerialNumberPayload
     */
    mac_address: string;
    /**
     * 
     * @type {string}
     * @memberof AddSerialNumberPayload
     */
    serial_number: string;
}

/**
 * Check if a given object implements the AddSerialNumberPayload interface.
 */
export function instanceOfAddSerialNumberPayload(value: object): value is AddSerialNumberPayload {
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    if (!('serial_number' in value) || value['serial_number'] === undefined) return false;
    return true;
}

export function AddSerialNumberPayloadFromJSON(json: any): AddSerialNumberPayload {
    return AddSerialNumberPayloadFromJSONTyped(json, false);
}

export function AddSerialNumberPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddSerialNumberPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'mac_address': json['mac_address'],
        'serial_number': json['serial_number'],
    };
}

export function AddSerialNumberPayloadToJSON(json: any): AddSerialNumberPayload {
    return AddSerialNumberPayloadToJSONTyped(json, false);
}

export function AddSerialNumberPayloadToJSONTyped(value?: AddSerialNumberPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mac_address': value['mac_address'],
        'serial_number': value['serial_number'],
    };
}

